// import React from 'react';
// import image1 from './../Assets/image1.jpg';
// import image2 from './../Assets/image2.jpg';
// import image3 from './../Assets/image3.jpg';
// import { NavLink } from 'react-router-dom';
// import './Middlecontent.css';

// const Middlecontent = () => {
//   return (
//     <div className="bg-[#F5F4F4]">
//       {/* Hero Banner */}
//       <div>
//         <div className="banner relative">
//           <div className="w-full h-full contentdiv p-10 flex">
//             <div className="lg:w-[35%] md:w-full sm:w-full w-full mt-36">
//               <div className="title">AUTOMATION & CONTROL EXPERTS</div>
//               <div className="text">
//                 We design and engineer custom-automated control solutions that
//                 reduce your costs and give your business the competitive edge it
//                 needs to succeed.
//               </div>
//               <button className="btn1">LEARN MORE</button>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* OUR SERVICES Section */}
//       <div className="bg-[#F5F4F4] py-16 relative z-0">
//         <div className="w-[90%] mx-auto text-center">
//           {/* Heading */}
//           <h2 className="text-3xl lg:text-4xl font-bold text-gray-800 tracking-wide mb-6">
//             OUR <span className="text-[#F49100]">SERVICES</span>
//           </h2>

//           {/* Description */}
//           <p className="text-gray-600 max-w-3xl mx-auto text-base lg:text-lg leading-relaxed mb-12">
//             From concept to production, we are committed to developing, building
//             and maintaining quality automation systems that help you reach your
//             goals. Whether your aim is reduced downtime, improved quality,
//             increased efficiency and productivity, enhanced safety, or reduced
//             energy costs, we’re here to help with professional service and
//             expertise you can rely on.
//           </p>

//           {/* Service Cards */}
//           <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-8">
//             {/* Card 1 */}
//             <div className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition duration-300 ease-in-out">
//               <div className="p-4">
//                 <img
//                   src={image1}
//                   alt="Front Bumper Punching SPM"
//                   className="rounded-xl w-full h-56 object-contain p-2 bg-[#F5F4F4]"
//                 />
//               </div>
//               <div className="p-6">
//                 <h3 className="text-xl font-semibold uppercase text-gray-800 mb-3">
//                   FR Bumper Punching spm
//                 </h3>
//                 <p className="text-gray-600 text-sm leading-relaxed">
//                   The DUV596 - Front Bumper Upper Fascia Punching and Ultrasonic
//                   Welding SPM is a state-of-the-art Special Purpose Machine (SPM)
//                   designed by Metrolab Automation Pvt. Ltd.
//                 </p>
//                 <p className="mt-4 text-[#F49100] font-semibold cursor-pointer hover:underline">
//                   READ MORE...
//                 </p>
//               </div>
//             </div>

//             {/* Card 2 */}
//             <div className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition duration-300 ease-in-out">
//               <div className="p-4">
//                 <img
//                   src={image2}
//                   alt="Rap Cap Box Post Process SPM"
//                   className="rounded-xl w-full h-56 object-contain p-2 bg-[#F5F4F4]"
//                 />
//               </div>
//               <div className="p-6">
//                 <h3 className="text-xl font-semibold uppercase text-gray-800 mb-3">
//                   RAP CAP BOX POST process spm
//                 </h3>
//                 <p className="text-gray-600 text-sm leading-relaxed">
//                   An advanced and highly efficient solution designed and
//                   manufactured by Metrolab Automation Pvt. Ltd., specifically
//                   tailored for high-precision punching applications.
//                 </p>
//                 <p className="mt-4 text-[#F49100] font-semibold cursor-pointer hover:underline">
//                   READ MORE...
//                 </p>
//               </div>
//             </div>

//             {/* Card 3 */}
//             <div className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition duration-300 ease-in-out">
//               <div className="p-4">
//                 <img
//                   src={image3}
//                   alt="Sports Hoop Multihead SPM"
//                   className="rounded-xl w-full h-56 object-contain p-2 bg-[#F5F4F4]"
//                 />
//               </div>
//               <div className="p-6">
//                 <h3 className="text-xl font-semibold uppercase text-gray-800 mb-3">
//                   SPORTS HOOP multihead spm
//                 </h3>
//                 <p className="text-gray-600 text-sm leading-relaxed">
//                   The J73 - Sports Hoop Multihead Ultrasonic Welding SPM is a
//                   highly advanced Special Purpose Machine (SPM) designed by
//                   Metrolab Automation Pvt. Ltd.
//                 </p>
//                 <p className="mt-4 text-[#F49100] font-semibold cursor-pointer hover:underline">
//                   READ MORE...
//                 </p>
//               </div>
//             </div>
//           </div>

//           {/* Button */}
//           <div className="mt-12">
//             <NavLink to="/services">
//               <button className="px-8 py-3 bg-[#F49100] text-white font-bold shadow-md hover:shadow-xl hover:bg-[#d97900] transition duration-300 ease-in-out">
//                 VIEW ALL SERVICES
//               </button>
//             </NavLink>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Middlecontent;

import React from 'react';
import image1 from './../Assets/Automation & Robotic Solutions.webp';
import image2 from './../Assets/Engineering Services.webp';
import image3 from './../Assets/Fixtures & Toolings.webp';
import image4 from './../Assets/Ergonomic Lift Assist.webp';
import { NavLink } from 'react-router-dom';
import './Middlecontent.css';

const Middlecontent = () => {
  const products = [
    {
      title: "Automation & Robotic Solutions",
      content:
        "Introduced automation & robotic solutions including SPMs, assembly lines & robotic cells to improve efficiency, safety, and production quality.",
      image: image1,
      link: "/Automation_robotics",
    },
    {
      title: "Engineering Services",
      content:
        "Expanded product lines to include engineering services such as design, automation, robotics & PLC controls to meet customized client needs.",
      image: image2,
      link: "/Engineering_services",
    },
    {
      title: "Fixtures & Toolings",
      content:
        "Design & development of fixtures & toolings for welding, checking & holding fixtures to optimize production workflows and precision.",
      image: image3,
      link: "/FixturesToolings",
    },
    {
      title: "Ergonomic Lift Assist & Powertrain Conveyor",
      content:
        "Implementation of ergonomic lift assist & powertrain conveyor systems for improved efficiency, safety, and reduced manual strain on workers.",
      image: image4,
      link: "/ergonomic",
    },
  ];

  return (
    <div className="bg-[#F5F4F4]">
      {/* Hero Banner */}
      <div>
        <div className="banner relative">
          <div className="w-full h-full contentdiv p-10 flex">
            <div className="lg:w-[55%] md:w-full sm:w-full w-full mt-36">
              <div className="title">AUTOMATION & CONTROL EXPERTS</div>
              <div className="text">
                We design and engineer custom-automated control solutions that
                reduce your costs and give your business the competitive edge it
                needs to succeed.
              </div>
              <button className="btn1">LEARN MORE</button>
            </div>
          </div>
        </div>
      </div>

      {/* PRODUCTS & SERVICES Section */}
      <div className="bg-[#F5F4F4] py-16 relative z-0">
        <div className="w-[90%] mx-auto text-center">
          {/* Heading */}
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-800 tracking-wide mb-6">
            OUR <span className="text-[#F49100]">PRODUCTS & SERVICES</span>
          </h2>

          {/* Description */}
          <p className="text-gray-600 max-w-3xl mx-auto text-base lg:text-lg leading-relaxed mb-12">
            From concept to production, we are committed to developing, building
            and maintaining quality automation systems that help you reach your
            goals. Whether your aim is reduced downtime, improved quality,
            increased efficiency and productivity, enhanced safety, or reduced
            energy costs, we’re here to help with professional service and
            expertise you can rely on.
          </p>

          {/* Product Cards */}
          <div className="grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-10 mb-12">
            {products.map((product, index) => (
              <div
                key={index}
                className="relative group bg-white rounded-3xl shadow-xl overflow-hidden cursor-pointer transform transition duration-500 hover:scale-105 hover:-translate-y-2 hover:shadow-2xl"
              >
                <img
                  src={product.image}
                  alt={product.title}
                  className="w-full h-64 object-cover group-hover:scale-110 transition duration-500"
                />
                <div className="p-6 text-left">
                  <h3 className="text-2xl font-bold text-gray-800 mb-3 group-hover:text-[#F49100] transition duration-300">
                    {product.title}
                  </h3>
                  <p className="text-gray-700 text-sm lg:text-base leading-relaxed mb-4">
                    {product.content}
                  </p>
                  <NavLink
                    to={product.link}
                    className="inline-block text-[#F49100] font-semibold hover:text-black hover:underline transition duration-300"
                  >
                    Know More
                  </NavLink>
                </div>
              </div>
            ))}
          </div>

          {/* View All Products & Services Button */}
          <NavLink to="/Products_services">
            <button className="px-10 py-3 bg-[#F49100] text-white font-bold shadow-md hover:shadow-xl hover:bg-[#d97900] transition duration-300 ease-in-out rounded-lg">
              VIEW ALL PRODUCTS & SERVICES
            </button>
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default Middlecontent;
